import { render, staticRenderFns } from "./UserProfilePassword.vue?vue&type=template&id=7a4aa1a0&scoped=true&"
import script from "./UserProfilePassword.vue?vue&type=script&lang=js&"
export * from "./UserProfilePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4aa1a0",
  null
  
)

export default component.exports